import { useHomeContext } from "../../contexts/HomeContext";
import Container from "../Container";
import Card from "../Card";
import AssetAllocationCardItem from "./AssetAllocationCardItem";

export default function AssetAllocationCard() {
    const homeContext = useHomeContext();
    
    const cards = [
        {
            name: "Renda Fixa",
            color: "bg-fixed-income",
            percentage: homeContext.wallet?.fixedIncomeTotalPercentage ?? 0,
            value: homeContext.wallet?.fixedIncomeTotalValue ?? 0
        },
        {
            name: "Renda Variável",
            color: "bg-variable-income",
            percentage: homeContext.wallet?.variableIncomeTotalPercentage ?? 0,
            value: homeContext.wallet?.variableIncomeTotalValue ?? 0
        },
        {
            name: "Em caixa",
            color: "bg-cashflow-income",
            percentage: homeContext.wallet?.cashUserTotalPercentage ?? 0,
            value: homeContext.wallet?.cashUserTotalValue ?? 0
        },
        {
            name: "Veículos",
            color: "bg-vehicles",
            percentage: homeContext.wallet?.vehiclesTotalPercentage ?? 0,
            value: homeContext.wallet?.vehiclesTotalValue ?? 0
        },
        {
            name: "Imóveis",
            color: "bg-properties",
            percentage: homeContext.wallet?.propertiesTotalPercentage ?? 0,
            value: homeContext.wallet?.propertiesTotalValue ?? 0
        }
    ];

    return (
        <Card
            isLoading={homeContext.isLoading}
            title="Alocação de ativos"
            subTitle="Agrupamento de alocação de ativos"
        >
            <Container wrap fullWidth gap={3}>
                {
                    cards
                        .filter(card => card.percentage > 0)
                        .sort((a, b) => b.percentage - a.percentage)
                        .map((card) => (
                            <AssetAllocationCardItem
                                key={card.name}
                                name={card.name}
                                percentage={card.percentage}
                                value={card.value}
                                color={card.color}
                            />
                        ))
                }
            </Container>
        </Card>
    );
}
